import React from "react";
import ReadSectionCard from "./Components/ReadSectionCard";
import { displayDateText } from "@Util/moment.util";

const SuspensionSectionByRead = props => {
  const { suspendStartDate, suspendEndDate, suspendReasonText, suspendNote } = props;

  const items =  [
    {
      key: "suspendStartDate",
      label: "暫停期間",
      xs: 6,
      value: displayDateText(suspendStartDate, suspendEndDate, {
        format: "YYYY/MM",
      }),
    },
    {
      key: "suspendReasonText",
      label: "暫停原因",
      xs: 6,
      value: suspendReasonText,
    },
    {
      key: "suspendNote",
      label: "暫停原因補充說明",
      xs: 12,
      value: suspendNote,
    },
  ];


  return (
    <ReadSectionCard
      title="暫停"
      outlined
      borderColor="#f44336"
      headerBg="#e57373"
      gridSpacing={3}
      hideEmpty={false}
      items={items}
    />
  );
};

export default SuspensionSectionByRead;
